@if (isContentLoading()) {
<mat-progress-bar class=" rounded layout-shop__progress-bar" mode="indeterminate" value="accent"></mat-progress-bar>
}

<!-- The closed-market notice, in the page's own band above the rail and the grid rather than as
     the first thing inside the scrolling column — which is why it used to stop at the filter
     panel (ELIO-3875, Dylan on 2026-10-22: "spans the entire page instead of stopping at the
     filter"). Out here it also stops scrolling away with the catalogue: it states when the
     market reopens, which is as true at the foot of the list as at the top.

     Desktop only, and the copy below lg is the second instance further down. Nothing is wrong
     with the notice on a phone — there is no rail beside the grid there, the filters are a
     sheet over it, so it already runs the full width — and moving it out of the column on that
     ramp would only hang the grid 74px past the bottom of the screen, since the column sizes
     itself from the viewport below lg. Two instances rather than one that moves: which of the
     two is drawn is a question about the width, and `d-lg-grid` answers it without asking the
     TypeScript for a breakpoint it would have to keep in step with this stylesheet. -->
@if(!marketStatus().isOpen) {
<div class="closed-market-container closed-market-container--page animated fadeIn d-none d-lg-grid">
  <div class="alert" role="alert">
    <span class="material-symbols-outlined mat-icon-fill icon">
      calendar_today
    </span>
    <div class="text-container">

      <p class="header">{{closedMarket().title}}</p>
      <p class="legend">{{closedMarket().legend}}</p>
    </div>
  </div>
</div>
}

<div class="layout-shop" [class.layout--sidebar-closed]="!isSidebarOpen()">
  <!-- Sidebar — rendered unconditionally so the 250px desktop slot is reserved
       from first paint. Hiding behind @if(isContentLoaded()) caused layoutShopMain
       (flex-grow:1) to shift horizontally 250px when products finished loading,
       which Lighthouse reported as the main CLS culprit. -->
  <div class="layout-shop__sidebar" [class.sidebar--closed]="!isSidebarOpen()"
    [class.height-layout]="!hasGlobalMessages()" [class.height-layout-global-message]="hasGlobalMessages()">
    <div class="overlay" (click)="toggleSidebar()"></div>
    <app-sidebar (outIsMenuReady)="scrollIntoView()"></app-sidebar>
    <div class="toggle-sidebar" (click)="toggleSidebar()" (mouseenter)="toggleCollapseBarHover(true)"
      (mouseleave)="toggleCollapseBarHover(false)">

      <!-- A plain caret, which is the control the library draws in this corner (node 1195:24318);
           the double chevron it replaces was a different glyph from every other caret on the rail. -->
      <i [ngClass]="{
          'fas': true,
          'toggle-sidebar__icon': true,
          'fa-caret-right': !isSidebarOpen(),
          'fa-caret-left': isSidebarOpen(),
        }"></i>
    </div>
  </div>
  <!-- Main content -->
  <div class="layout-shop__main" [class.padding-top-whitout-filter-tags]="!showFiltersTags() && !filters().size"
    [class.height-layout-shop__main]="!hasGlobalMessages()"
    [class.height-layout-shop__main-global-message]="hasGlobalMessages()" (scroll)="onScroll($event)" #layoutShopMain
    id="layoutShopMain">

    @if (showFiltersTags() || filters().size) {
    <div class="filters">

      <!-- Filter tags -->
      @if (showFiltersTags()) {
      <section class="filter-tags" id="filterTags">
        @for (item of sidebarService.filterTags(); track item.listId + '-' + item.sublistId) {
        <div class="filter-tags__tag">
          <span>
            {{item.name}}
          </span>
          <i class="material-symbols-outlined" (click)="sidebarService.removeTag(item)">
            close
          </i>
        </div>
        }
        @if (showMoreItemTags()) {
        <span class="material-symbols-outlined more">
          more_horiz
        </span>
        }
      </section>
      }

      <!-- Filter text -->
      @if (filters().size) {
      <ul class="filter-chips-container">
        @for (filter of filters().entries(); track $index) {
        <li>
          <mat-chip-row (removed)="removeChipFilter(filter[0])" [editable]="true" class="bg-secondary bg-opacity-25">
            <div class="d-flex gap-1">
              <b>{{filter[1].type}}:</b> <span class="fst-italic text-decoration-underline">{{filter[1].value}}</span>
            </div>
            <button matChipRemove [attr.aria-label]="'remove ' + filter[0]">
              <span class="material-symbols-outlined">
                close
              </span>
            </button>
          </mat-chip-row>
        </li>
        }
      </ul>
      }

    </div>
    }

    <!-- The phone's copy of the notice: inside the scrolling column, where it has always been.
         See the instance above the rail for why there are two. -->
    @if(!marketStatus().isOpen) {
    <div class="closed-market-container animated fadeIn d-lg-none">
      <div class="alert" role="alert">
        <span class="material-symbols-outlined mat-icon-fill icon">
          calendar_today
        </span>
        <div class="text-container">

          <p class="header">{{closedMarket().title}}</p>
          <p class="legend">{{closedMarket().legend}}</p>
        </div>
      </div>
    </div>
    }

    <div class="container-fluid" id="scroll-to-top-ref">

      @if (isInSearchMode()) {
      <div class="search-mode-banner animated fadeIn">
        <div class="search-mode-banner__info">
          <!-- <span class="material-symbols-outlined search-mode-banner__icon">search</span> -->
          <span>Results for "<strong>{{ searchModeQuery() }}</strong>"</span>
          <span class="search-mode-banner__count">({{ searchResultCount() }})</span>
        </div>
        <button class="search-mode-banner__clear" type="button" (click)="exitSearchMode()">
          <span class="material-symbols-outlined">close</span>
          Clear search
        </button>
      </div>
      }

      @if (!isContentLoading() && isContentLoaded()) {
      @if (!productsSignal().length) {
      <app-empty-message [message]="emptyMessage" class="mt-4"></app-empty-message>
      }
      }

      <!-- Single source of truth for a product card cell — rendered eagerly for the
           first row(s) and with deferred hydration for the rest (see the @for below). -->
      <ng-template #productCard let-product let-index="index">
        <div class="col-lg-4 col-6" id="{{product.id}}" (mouseenter)="onProductCardHover(product.id)">
          <div class="product-card-grid__item">
            <app-product-card-v2
              [cardResume]="{ product, settings: {}, productDetails: productDetails().get(product.id) }"
              (onComponentReady)="onProductCardReady(product.id)"
              [isFromShop]="!!productDetails().get(product.id)"
              [isAboveTheFold]="index < 4">
            </app-product-card-v2>
          </div>
        </div>
      </ng-template>

      <div class="row product-card-grid" [class.padding-at-bottom-sm]="productsSignal().length <= 3">
        @if (productsSignal()) {

        @for (product of productsSignal(); track (product.id + '-' + $index); let isFirstProduct = $first) {

        <!-- CATEGORY -->
        <!-- @if (product.categoryInView && product.categoryInView.show) {
        <div #subcategory [attr.shop-data-anchor-link]="product.categoryAnchorLink"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="-1">
          @if (product.categoryInView.banner) {
          <a [href]="product.categoryInView.url ? product.categoryInView.url : 'javascrip:void(0)'"
            [attr.category-id]="product.category.id" [id]="product.category.id">
            <img [src]="product.categoryInView.banner" alt="Banner of category: {{product.category.name}}"
              class="img-fluid animated fadeInDown w-100 mb-4">
          </a>
          } @else if(displayCategoryName()) {
          <h3 class="category fw-bold" [attr.category-id]="product.category.id" [id]="product.category.id">
            {{ product.category.name }}
          </h3>
          }
        </div>
        } -->

        <!-- SUB-CATEGORY -->
        @if (!isInSearchMode() && product.subCategoryInView && product.subCategoryInView.show) {
        <div #subcategory [attr.shop-data-anchor-link]="product.subcategoryAnchorLink"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id">
        </div>
        @if (product.subCategoryInView.banner) {
        @let bannerUrl = product.subCategoryInView.url;
        @let bannerId = product.category.id + '-' + product.subcategory.id;
        <a (click)="onBannerClicked(bannerUrl, bannerId)" href="javascript:void(0)" [id]="bannerId"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id" #subcategory>
          <picture>
            <source media="(max-width: 768px)" [srcset]="product.subCategoryInView.bannerMobile || product.subCategoryInView.banner">
            <source media="(min-width: 769px)" [srcset]="product.subCategoryInView.bannerDesktop || product.subCategoryInView.banner">
            <!-- First product's subcategory banner is the LCP candidate on /shop —
                 eager + high priority. Subsequent banners stay lazy + low for bandwidth. -->
            <img [src]="product.subCategoryInView.bannerDesktop || product.subCategoryInView.banner"
              alt="Banner of subcategory: {{product.subcategory.name}}"
              class="img-fluid animated fadeInDown w-100 mb-4"
              [attr.loading]="isFirstProduct ? 'eager' : 'lazy'"
              decoding="async"
              [attr.fetchpriority]="isFirstProduct ? 'high' : 'low'">
          </picture>
        </a>
        } @else {
        <h3 class="category" [id]="product.category.id + '-' + product.subcategory.id"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id" #subcategory>
          {{ product.subcategory.name }}
        </h3>
        }
        }

        <!-- SUB-CATEGORY-SON -->
        @if (!isInSearchMode() && product.subCategorySonInView && product.subCategorySonInView.show) {
        <div #subcategorySon [attr.shop-data-anchor-link]="product.subcategorySonAnchorLink"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id"
          [attr.sub-category-son-id]="product.subcategorySon.id">
        </div>
        @if (product.subCategorySonInView.banner) {
        @let bannerUrl = product.subCategorySonInView.url;
        @let bannerId = product.category.id + '-' + product.subcategory.id + '-' + product.subcategorySon.id;
        <a (click)="onBannerClicked(bannerUrl, bannerId)" href="javascript:void(0)" [id]="bannerId"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id"
          [attr.sub-category-son-id]="product.subcategorySon.id" #subcategorySon>
          <picture>
            <source media="(max-width: 768px)" [srcset]="product.subCategorySonInView.bannerMobile || product.subCategorySonInView.banner">
            <source media="(min-width: 769px)" [srcset]="product.subCategorySonInView.bannerDesktop || product.subCategorySonInView.banner">
            <img [src]="product.subCategorySonInView.bannerDesktop || product.subCategorySonInView.banner"
              alt="Banner of subcategory: {{product.subcategorySon.name}}"
              class="img-fluid animated fadeInDown w-100 mb-4"
              [attr.loading]="isFirstProduct ? 'eager' : 'lazy'"
              decoding="async"
              [attr.fetchpriority]="isFirstProduct ? 'high' : 'low'">
          </picture>
        </a>
        } @else {
        <h3 class="category" [id]="product.category.id + '-' + product.subcategory.id + '-' + product.subcategorySon.id"
          [attr.category-id]="product.category.id" [attr.sub-category-id]="product.subcategory.id"
          [attr.sub-category-son-id]="product.subcategorySon.id" #subcategorySon>
          {{ product.subcategorySon.name }}
        </h3>
        }
        }

        @if ($index < 12) {
        <!-- Above-the-fold: eager, no @defer. Server-rendered and interactive on
             hard reload / direct category load — this is what removes the blank.
             Cards render from ProductResume on first paint and merge batched detail
             in-place on the client (see ProductCardV2 #cardResumeTransform), so a
             higher eager count adds real content without waiting on the detail fetch.
             Threshold is tunable — bounded by SSR HTML size / TTFB. -->
        <ng-container [ngTemplateOutlet]="productCard"
          [ngTemplateOutletContext]="{ $implicit: product, index: $index }"></ng-container>
        } @else {
        <!-- Below-the-fold: NOT server-rendered. A lightweight @placeholder is sent
             in the SSR HTML (cheap — keeps TTFB low) and the real card renders on the
             client when it scrolls into view. Rendering all ~250 heavy cards on the
             server ballooned the HTML to ~1.5MB and TTFB to several seconds. Keeping the
             card deferred ALSO gates the batched product-detail fetch to visible cards
             (onComponentReady fires only when a card mounts) — do NOT force-render the
             whole grid or every card requests its detail at once. -->
        @defer (on viewport; prefetch on immediate) {
        <ng-container [ngTemplateOutlet]="productCard"
          [ngTemplateOutletContext]="{ $implicit: product, index: $index }"></ng-container>
        } @placeholder {
        <div class="col-lg-4 col-6 product-card-placeholder" id="{{product.id}}">
          <section class="d-flex flex-column flex-grow-1">
            <div class="product-card__head"></div>
            <div class="product-card__img-wrap">
              <a>
                <div class="product-card__img"></div>
              </a>
            </div>
            <div style="height: 150px;"></div>
          </section>
        </div>
        }
        }
        }
        }
      </div>
    </div>
  </div>
</div>